module.exports = __webpack_public_path__ + "c4a490b5f02cb9cac8fd9234ca648f5c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-football.png
// module id = 1958
// module chunks = 0